import React from 'react';
import { FormProvider } from 'react-hook-form';

import FlowRendererComponent from "conversie-flow-bundle/assets/js/components/flow/renderers/FlowRendererComponent";
import FlowFieldChoice from "conversie-flow-bundle/assets/js/components/flow/fields/FlowFieldChoice";

/* Components */
import ConversionFlowDatalayer from './ConversionFlowDatalayer';
import ConversionFlowPrices from './ConversionFlowPrices';
import ConversionFlowSubmit from './ConversionFlowSubmit';
import ConversionFlowVehicle from './ConversionFlowVehicle';
import ConversionFlowCustomerRating from './ConversionFlowCustomerRating';

/* Conversion Fields */
import ConversionFieldChoice from './fields/ConversionFieldChoice';

/* Conversion Components */
import ConversionComponentTradeInVehicle from './components/ConversionComponentTradeInVehicle';
import ConversionComponentsummary from './components/ConversionComponentSummary';
import ConversionComponentFinanceCalculator from './components/ConversionComponentFinanceCalculator';
import ConversionComponentLeaseCalculator from './components/ConversionComponentLeaseCalculator';

/* Common */
import { Icon, Button } from '~/components/common';
import CheckIcon from '~/../symbols/check.svg';
import ChevronIcon from '~/../symbols/chevron.svg';

/* Utilities */
import { trans, getCloudimageUrl } from '~/utilities';

export default function ConversionFlowForm({ form, flow, doRequest, handleClose, Banner, vehicleImage, activeStep, datalayerData, setStep, flowDisclaimer, klantenvertellenScore, conversionUsps, summaryMinimal }) {
    return (
        <form noValidate onSubmit={form.handleSubmit(() => doRequest({action: 'submit'}, 'submitting'))}>
            <ConversionFlowDatalayer activeStepId={flow?.steps?.find(step => step.active)?.id} flow={flow} datalayerData={datalayerData}/>
            <FormProvider {...form}>
                <div className="row gutters-8 gutters-lg-4 justify-content-around">
                    <div className={`col-12 ${flow?.summary ? 'col-lg-5' : ''}`}>
                        <div className="row gutters-2 gutters-lg-4">
                            {(flow?.form?.title || flow?.form?.intro) && (
                                <div className="col-12">
                                    {flow?.form?.title && (
                                        <p className="h5">{flow.form.title}</p>
                                    )}
                                    {flow?.form?.intro && (
                                        <p className="text-muted--60">{flow.form.intro}</p>
                                    )}
                                </div>
                            )}
                            <FlowRendererComponent
                                components={flow?.form?.components}
                                path={`form.components`}
                                id={`form-${flow?.flowId}.components`}
                                renderComponent={(component, props) => {
                                    if (component.name === 'trade-in-vehicle') {
                                        return (
                                            <ConversionComponentTradeInVehicle
                                                {...props}
                                            />
                                        );
                                    }

                                    if (component.name === 'finance-calculator' || component.name === 'financial-lease-calculator') {
                                        return (
                                            <ConversionComponentFinanceCalculator
                                                {...props}
                                            />
                                        );
                                    }

                                    if (component.name === 'vwpfs-lease-calculator') {
                                        return (
                                            <ConversionComponentLeaseCalculator
                                                {...props}
                                                summary={flow?.summary}
                                            />
                                        );
                                    }

                                    if (component.name === 'summary') {
                                        return (
                                            <ConversionComponentsummary
                                                summary={flow?.summary}
                                            />
                                        );
                                    }
                                }}
                                renderField={(field, props) => {
                                    if (field?.view && field.type === 'choice-radio') {
                                        return (
                                            <ConversionFieldChoice
                                                {...props}
                                                customControlClassName={`custom-control--${field.view}`}
                                                choiceColClassName={field.view === 'choice' ? 'col' : props?.colClassName}
                                                colClassName="col-12"
                                                inputType="radio"
                                            />
                                        );
                                    }

                                    if (field?.view && field.type === 'choice-checkbox') {
                                        return (
                                            <ConversionFieldChoice
                                                {...props}
                                                customControlClassName={`custom-control--${field.view}`}
                                                choiceColClassName={field.view === 'choice' ? 'col' : props?.colClassName}
                                                colClassName="col-12"
                                                inputType="checkbox"
                                            />
                                        );
                                    }

                                    if (field.type === 'interest-checkbox') {
                                        return (
                                            <FlowFieldChoice
                                                {...props}
                                                inputType="checkbox"
                                            />
                                        );
                                    }
                                }}
                            />

                            {activeStep?.position === 1 && flow?.flowName === 'private_lease' &&
                                <div className="col-6 d-flex align-items-center">
                                    <p className="font-weight-bold mb-0">
                                        {flow?.summary?.prices?.['private-lease']?.price}
                                    </p>
                                </div>
                            }

                            {activeStep?.position > 1 &&
                                <div className="col-6 d-flex align-items-center">
                                    <Button
                                        title="Vorige stap"
                                        theme="none"
                                        className={"btn--reversed gap-1 text-muted--60"}
                                        textClassName={"text--14"}
                                        icon={ChevronIcon}
                                        iconSize={14}
                                        iconClassName={"rotate-180"}
                                        showIcon={true}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            const activeIndex = flow?.steps.indexOf(activeStep);
                                            const prevStep = flow?.steps[activeIndex - 1];
                                            setStep(prevStep);
                                        }}
                                    />
                                </div>
                            }

                            {flow?.form?.buttonLabel && (
                                <div className={`col${flow?.flowName === 'interest' && activeStep?.position === 1 ? '-12' : ''} mt-auto ml-auto text-right`}>
                                    <ConversionFlowSubmit
                                        flow={flow}
                                        handleClose={handleClose}
                                    />
                                </div>
                            )}

                            {Banner && (
                                <>
                                    <div className="col-12">
                                        <hr className="mt-8 mb-4"/>
                                        <p className="text-muted--60 text--14">{trans('app.flow.finance.calculator.rate_title', {'finance_rate': (flow.summary.vehicle.finance * 100)})}</p>

                                        <div key={'banner'}>
                                            <Banner/>
                                        </div>
                                    </div>
                                </>
                            )}
                            {flowDisclaimer !== '' &&
                                <div className="col-12">
                                    <p className="text-muted--60 text--14">{flowDisclaimer}</p>
                                </div>
                            }
                        </div>
                    </div>
                    {flow?.summary && (
                        <div className="col-12 col-lg-4 col-xl-3 offset-xl-1">
                            <div className="card card--summary">
                                <div className="card-body">
                                    <ConversionFlowCustomerRating
                                        klantenvertellenScore={klantenvertellenScore}
                                    />
                                    {conversionUsps ?
                                        conversionUsps.map((usp, index) => (
                                            <div key={index} className="d-flex gap-2 align-items-center">
                                                <Icon
                                                    theme="base"
                                                    size={24}
                                                    url={CheckIcon.url}
                                                    className="flex-shrink-0"
                                                />
                                                <p className="text--16 text-muted--60">{usp.title}</p>
                                            </div>
                                        ))
                                    : null}
                                </div>
                            </div>

                            <div className="card card--summary">
                                <img
                                    className="img-fluid"
                                    src={getCloudimageUrl(vehicleImage, {w: 940, h: 627, func: 'crop'})}
                                    srcSet={`${getCloudimageUrl(vehicleImage, {w: 1880, h: 1254, func: 'crop'})} 2x`}
                                    width="940"
                                    height="627"
                                    alt=""
                                />
                                <div className="card-body">
                                    <ConversionFlowVehicle
                                        summary={flow?.summary}
                                        summaryMinimal={summaryMinimal}
                                    />
                                    <ConversionFlowPrices
                                        summary={flow?.summary}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </FormProvider>
        </form>
    )
}
